import React from 'react';

const MoreFeatures = () => {
  const features = [
    {
      id: 1,
      title: 'Car Hire Services',
      description: 'Rent vehicles for your journeys with our comprehensive car hire service',
      icon: '🚗',
      status: 'Available',
      action: 'car-hire'
    },
    {
      id: 2,
      title: 'Construction Equipment',
      description: 'Heavy machinery and equipment rental for construction projects',
      icon: '🏗️',
      status: 'Coming Soon',
      action: '#'
    },
    {
      id: 3,
      title: 'Online Shopping',
      description: 'Shop from our wide range of products with delivery services',
      icon: '🛒',
      status: 'Coming Soon',
      action: '#'
    },
    {
      id: 4,
      title: 'Food Delivery',
      description: 'Order food from your favorite restaurants with fast delivery',
      icon: '🍔',
      status: 'Coming Soon',
      action: '#'
    },
    {
      id: 5,
      title: 'Package Delivery',
      description: 'Send and receive packages with our reliable delivery service',
      icon: '📦',
      status: 'Coming Soon',
      action: '#'
    },
    {
      id: 6,
      title: 'Event Transportation',
      description: 'Special transportation services for events and occasions',
      icon: '🎉',
      status: 'Coming Soon',
      action: '#'
    },
    {
      id: 7,
      title: 'Airport Transfers',
      description: 'Professional airport pickup and drop-off services',
      icon: '✈️',
      status: 'Coming Soon',
      action: '#'
    },
    {
      id: 8,
      title: 'Corporate Services',
      description: 'Tailored transportation solutions for businesses',
      icon: '💼',
      status: 'Coming Soon',
      action: '#'
    }
  ];

  const handleFeatureClick = (feature) => {
    if (feature.action !== '#') {
      alert(`Opening ${feature.title} - This would navigate to ${feature.action}`);
    } else {
      alert(`${feature.title} is coming soon! Stay tuned for updates.`);
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.infoSection}>
        <h2 style={styles.sectionTitle}>No New Features Yet</h2>
        <p style={styles.noFeaturesMessage}>
          We're working hard to bring you exciting new features! 
          Check back soon for updates and enhancements to your XGO experience.
        </p>
      </div>
    </div>
  );
};

const styles = {
  container: {
    fontFamily: 'Arial, sans-serif',
    maxWidth: '1200px',
    margin: '0 auto',
    padding: '20px',
    backgroundColor: '#f8f9fa'
  },
  header: {
    textAlign: 'center',
    marginBottom: '40px',
    backgroundColor: '#007bff',
    color: 'white',
    padding: '30px',
    borderRadius: '10px'
  },
  title: {
    fontSize: '2.5rem',
    margin: '0',
    marginBottom: '10px'
  },
  subtitle: {
    fontSize: '1.2rem',
    margin: '0',
    opacity: 0.9
  },
  featuresGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
    gap: '20px',
    marginBottom: '40px'
  },
  featureCard: {
    backgroundColor: 'white',
    padding: '20px',
    borderRadius: '10px',
    boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
    textAlign: 'center',
    cursor: 'pointer'
  },
  availableCard: {
    border: '2px solid #28a745',
    padding: '20px',
    borderRadius: '10px',
    boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
    textAlign: 'center',
    cursor: 'pointer'
  },
  comingSoonCard: {
    border: '2px solid #6c757d',
    opacity: 0.8,
    padding: '20px',
    borderRadius: '10px',
    boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
    textAlign: 'center',
    cursor: 'pointer'
  },
  featureIcon: {
    fontSize: '4rem',
    marginBottom: '15px'
  },
  featureTitle: {
    fontSize: '1.5rem',
    margin: '0 0 10px 0',
    color: '#333'
  },
  featureDescription: {
    fontSize: '1rem',
    color: '#666',
    margin: '0 0 15px 0',
    lineHeight: '1.4'
  },
  featureStatus: {
    marginTop: '15px'
  },
  statusBadge: {
    padding: '5px 15px',
    borderRadius: '20px',
    fontSize: '0.8rem',
    fontWeight: 'bold',
    textTransform: 'uppercase'
  },
  availableBadge: {
    backgroundColor: '#28a745',
    color: 'white'
  },
  comingSoonBadge: {
    backgroundColor: '#6c757d',
    color: 'white'
  },
  infoSection: {
    marginBottom: '40px'
  },
  noFeaturesMessage: {
    textAlign: 'center',
    fontSize: '1.1rem',
    color: '#666',
    lineHeight: '1.6',
    backgroundColor: '#f8f9fa',
    padding: '20px',
    borderRadius: '10px',
    border: '2px dashed #dee2e6'
  },
  sectionTitle: {
    textAlign: 'center',
    fontSize: '2rem',
    marginBottom: '30px',
    color: '#333'
  },
  benefits: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
    gap: '20px'
  },
  benefit: {
    backgroundColor: 'white',
    padding: '20px',
    borderRadius: '10px',
    textAlign: 'center',
    boxShadow: '0 2px 10px rgba(0,0,0,0.1)'
  },
  contactSection: {
    backgroundColor: 'white',
    padding: '30px',
    borderRadius: '10px',
    textAlign: 'center',
    boxShadow: '0 2px 10px rgba(0,0,0,0.1)'
  }
};

export default MoreFeatures;
